import { createBrowserRouter } from 'react-router';
import { RouterErrorBoundary, RouterLayout } from './components/RouterLayout';

export const quizRouter = createBrowserRouter(
  [
    {
      Component: RouterLayout,
      ErrorBoundary: RouterErrorBoundary,
      children: [
        {
          path: '/',
          lazy: async () => ({
            Component: (await import('./features/quizzes/routes/quiz-list')).QuizListPage,
          }),
        },
        {
          path: ':slug',
          lazy: async () => ({
            Component: (await import('./features/quizzes/routes/quiz-detail')).QuizDetailPage,
          }),
        },
        {
          path: ':slug/run',
          lazy: async () => ({
            Component: (await import('./features/quizzes/routes/quiz-runner')).QuizRunnerPage,
          }),
        },
        {
          path: ':slug/result',
          lazy: async () => ({
            Component: (await import('./features/quizzes/routes/quiz-result')).QuizResultPage,
          }),
        },
      ],
    },
  ],
  { basename: '/quiz' },
);
